<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="38px" viewBox="0 -960 960 960" width="38px" fill="currentColor">
        <path d="m608.92-141.54-256.84-90.69-167.08 66q-15.46 7.84-30.23-1.19Q140-176.46 140-194.54v-523q0-11.84 6.35-21.27 6.34-9.42 17.19-13.65l188.54-66 256.84 89.69L775-794.38q15.46-7.23 30.23.92T820-767.61v531.15q0 10.61-6.92 18.42-6.93 7.81-17.16 11.42l-187 65.08ZM583-198.08v-495l-206-70.23v495l206 70.23Zm45.38 0 146.23-48.15v-502l-146.23 55.15v495Zm-442.99-14.69 146.23-55.54v-495l-146.23 48.93v501.61Zm442.99-480.31v495-495Zm-296.76-70.23v495-495Z"/>
    </svg>
</template>

<script>
export default {
    name: 'MapIcon',
}
</script>